/**
 * Breakpoints - Soccer Analytics App
 * Puntos de quiebre para diseño responsive
 */

const breakpoints = {
  // Valores en píxeles
  values: {
    xs: 0,      // Extra small (móvil pequeño)
    sm: 600,    // Small (móvil grande)
    md: 900,    // Medium (tablet)
    lg: 1200,   // Large (desktop pequeño)
    xl: 1536,   // Extra large (desktop grande)
  },

  // Nombres descriptivos
  mobile: 600,      // 0-600px
  tablet: 1024,     // 601-1024px
  desktop: 1025,    // 1025px+
  wide: 1440,       // Pantallas anchas

  // Media queries helpers
  up: (breakpoint) => {
    const value = breakpoints.values[breakpoint] || breakpoint;
    return `@media (min-width: ${value}px)`;
  },

  down: (breakpoint) => {
    const value = breakpoints.values[breakpoint] || breakpoint;
    return `@media (max-width: ${value - 1}px)`;
  },

  between: (min, max) => {
    const minValue = breakpoints.values[min] || min;
    const maxValue = breakpoints.values[max] || max;
    return `@media (min-width: ${minValue}px) and (max-width: ${maxValue - 1}px)`;
  },

  only: (breakpoint) => {
    const keys = Object.keys(breakpoints.values);
    const index = keys.indexOf(breakpoint);
    if (index === -1) return '';
    if (index === keys.length - 1) {
      return breakpoints.up(breakpoint);
    }
    const nextBreakpoint = keys[index + 1];
    return breakpoints.between(breakpoint, nextBreakpoint);
  },
};

// CSS Media Queries predefinidas
export const mediaQueries = {
  // Mobile first
  mobile: `@media (max-width: ${breakpoints.mobile - 1}px)`,
  tablet: `@media (min-width: ${breakpoints.mobile}px) and (max-width: ${breakpoints.tablet - 1}px)`,
  desktop: `@media (min-width: ${breakpoints.desktop}px)`,
  
  // Specific sizes
  smallMobile: '@media (max-width: 374px)',
  largeMobile: '@media (min-width: 375px) and (max-width: 599px)',
  
  // Orientación
  landscape: '@media (orientation: landscape)',
  portrait: '@media (orientation: portrait)',
  
  // Densidad de píxeles
  retina: '@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi)',
  
  // Preferencias de usuario
  reducedMotion: '@media (prefers-reduced-motion: reduce)',
  darkMode: '@media (prefers-color-scheme: dark)',
  lightMode: '@media (prefers-color-scheme: light)',
};

export default breakpoints;
